import { ChatFeedbackState, FeedbackVote } from './types'

/** Sunucudaki KAPALI küme ile birebir aynı sırada; etiketler yalnız burada yaşar (ADR-015). */
export const FEEDBACK_REASONS: { code: string; label: string }[] = [
  { code: 'misunderstood', label: 'Sorumu yanlış anladı' },
  { code: 'incomplete', label: 'Bilgi eksikti' },
  { code: 'incorrect', label: 'Bilgi yanlıştı' },
  { code: 'slow', label: 'Çok yavaştı' },
  { code: 'other', label: 'Diğer' },
]

const VOTES: FeedbackVote[] = ['up', 'down', 'none']

/** Olumsuz oydaki serbest yorumun üst sınırı; sunucu aşan metni reddeder (`InvalidComment`). */
export const FEEDBACK_COMMENT_MAX = 500

/** `chat/messages/{id}/feedback` gövdesi — backend C# adlarıyla birebir (PascalCase). */
export interface FeedbackPayload {
  Vote: FeedbackVote
  ReasonCode?: string
  Comment?: string
}

/**
 * İstek gövdesini kurar. Neden ve yorum yalnız olumsuz oyda taşınır (sunucu kuralının yansıması);
 * yorum kırpılır, boşsa gövdeye hiç girmez.
 */
export function buildFeedbackPayload(vote: FeedbackVote, reasonCode?: string, comment?: string): FeedbackPayload {
  const payload: FeedbackPayload = { Vote: vote }
  if (vote !== 'down') return payload
  if (reasonCode) payload.ReasonCode = reasonCode
  const trimmed = comment?.trim()
  if (trimmed) payload.Comment = trimmed
  return payload
}

/** Aynı düğmeye tekrar basmak oyu GERİ ALIR; diğer düğme yönü değiştirir. */
export function nextVote(current: FeedbackVote | undefined, clicked: 'up' | 'down'): FeedbackVote {
  return current === clicked ? 'none' : clicked
}

function pick(source: unknown, ...keys: string[]): unknown {
  if (!source || typeof source !== 'object') return undefined
  const record = source as Record<string, unknown>
  for (const key of keys) {
    if (record[key] !== undefined && record[key] !== null) return record[key]
  }
  return undefined
}

/**
 * Backend PascalCase yanıtını balon durumuna çevirir; tanınmayan oy "none" sayılır.
 * Neden yalnız olumsuz oyda taşınır — sunucudaki kuralın istemci tarafındaki yansıması.
 */
export function normalizeFeedbackState(value: unknown): ChatFeedbackState {
  const rawVote = pick(value, 'vote', 'Vote')
  const vote = VOTES.includes(rawVote as FeedbackVote) ? (rawVote as FeedbackVote) : 'none'
  const rawReason = pick(value, 'reasonCode', 'ReasonCode')
  const reasonCode = vote === 'down' && typeof rawReason === 'string' && rawReason ? rawReason : undefined

  return { vote, reasonCode }
}
